module.exports = __webpack_public_path__ + "static/img/chat3.ac6b2771.png";